import {createFeatureSelector, MemoizedSelector} from '@ngrx/store';
import {CustomFamiliesListState, FAMILIES_FEATURE, StateWithFamilies} from '../custom-families-state';


export const getFamiliesListState: MemoizedSelector<StateWithFamilies,
  CustomFamiliesListState> = createFeatureSelector<CustomFamiliesListState>(FAMILIES_FEATURE);
